<!--<ng-template [sbmodal]="'mediaexplorermodal'">
  <sb-custom-modal [templateId]="'mediaexplorermodal'">
    <div slot="body">
      <app-medium-explorer [customer]="customer" [modalType]="'bookingSelect'" [isInModalContext]="'mediaexplorermodal'"></app-medium-explorer>
    </div>
  </sb-custom-modal>
</ng-template>-->

<ul [ngClass]="{'tw-w-full tw-h-full': maxSize, 'tw-flex-row': bookingEditorView, 'tw-flex-col': !bookingEditorView}"
    class="tw-flex tw-gap-2 ">
  @for (element of filterElements; track idx; let idx = $index) {
    @if (bookingEditorView) {
      <li (click)="permissionService.hasPermission(permissionService.Permission.cull_show) ? openPreviewModal(element) :''"
          [ngClass]="{
         'tw-text-sbGray-600' : !element?.cull,
         'tw-cursor-pointer' : permissionService.hasPermission(permissionService.Permission.cull_show) && element?.cull,
         '!tw-text-sbBlue-500' : element?.active,
         'tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center': maxSize
         }"
          ngbTooltip="{{element?.cull?.name}}"
          class="tw-flex tw-items-center tw-min-w-12 tw-min-h-12 tw-gap-2 tw-px-4 tw-py-2 tw-rounded-md tw-bg-sbGray-50/50 dark:tw-text-white dark:tw-bg-sbGray-900"
          container="body" placement="top">
        <sb-icon [icon]="element.filterIcon"></sb-icon>
        @if (!maxSize && showCaption) {
          <span [innerHTML]="(element.cull?.name ?? '-') | truncate : 50"
                class="tw-mb-0 tw-block"></span>
        }
        @if (maxSize) {
          <span
            [innerHTML]="(element.cull ? element.cull.name : ('lang.globals.noCulls' | translate))|truncate: 15 "
            class="tw-font-bold "></span>
        }
      </li>

    } @else {
      <li (click)="permissionService.hasPermission(permissionService.Permission.cull_show) ? openPreviewModal(element) :''"
          [ngClass]="{
         'tw-text-sbGray-600' : !element.cull,
          'tw-cursor-pointer' : permissionService.hasPermission(permissionService.Permission.cull_show) && element?.cull,
          '!tw-text-sbBlue-500' : element?.active
          }"
          class="tw-flex tw-items-center tw-min-w-12 tw-gap-2">
        <sb-icon [icon]="element?.filterIcon"></sb-icon>
        @if (showCaption) {
          <span [innerHTML]="(element?.cull?.name ?? '-') | truncate : 50" class="tw-block"></span>
        }
      </li>
    }
  }
</ul>
